export default __webpack_public_path__ + "static/media/img2.fc40c40b.png";